import React, { useEffect, useState } from "react";
import { Container, Contact, Resume, Files, Actions } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import { MdDownload } from "react-icons/md";
import api from "../../../services/api";
import { toast } from "react-toastify";
import Status from "../../../components/status";
import { format, isToday } from "date-fns";
import { Message, ViewInput } from "../../../GlobalStyles";
import photoUser from "./../../../images/user.png";
import { Button, Modal, Select, Spin } from "antd";
import { getValue } from "../../../services/functions";

export default function OSDetailsAdmin() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [visibleModalMessage, setVisibleModalMessage] = useState(false);
  const [visibleModalSend, setVisibleModalSend] = useState(false);
  const [visibleModalHandle, setVisibleModalHandle] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [order, setOrder] = useState({});
  const [files, setFiles] = useState([]);
  const [collaborator_id, setCollaborator_id] = useState("");
  const [collaborators, setCollaborators] = useState([]);

  useEffect(() => {
    loadingOS();
  }, [id]);

  useEffect(() => {
    loadingTecnicos();
  }, []);

  async function loadingTecnicos() {
    await api
      .get(`/collaborators?all=true`)
      .then((response) => {
        setCollaborators(response.data.collaborators);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }
  async function loadingOS() {
    await api
      .get(`/order/${id}`)
      .then((response) => {
        setFiles(response.data.docs);
        setOrder(response.data);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function sendOS() {
    setIsLoadingModal(true);
    await api
      .put(`/send-order/${order.id}`, {
        collaborator_id: collaborator_id,
      })
      .then((response) => {
        setVisibleModalSend(false);
        let orderC = { ...order };
        orderC.collaborator = response.data.collaborator;
        orderC.collaborator_id = response.data.collaborator_id;
        setOrder(orderC);
        toast.success("Técnico selecionado para OS com sucesso");
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  async function handleTecnico() {
    setIsLoadingModal(true);
    await api
      .put(`/order/edit-tecnico/${order.id}`, {
        collaborator_id: collaborator_id,
      })
      .then((response) => {
        setVisibleModalHandle(false);
        let orderC = { ...order };
        orderC.collaborator = response.data.collaborator;
        orderC.collaborator_id = response.data.collaborator_id;
        setOrder(orderC);
        toast.success("Técnico alterado com sucesso");
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  return (
    <Container>
      {loading ? (
        <Spin style={{ marginTop: 50 }} />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <h1 style={{ marginRight: 0, marginBottom: 0 }}>Ordem de Serviço #{id}</h1>
            <Status status={order.status} />
            {order.urgent && (
              <Status isUrgent={true} style={{ marginLeft: 0 }} />
            )}
            {order.type && (
              <span
                style={{
                  background: order.type === "elaboracao" ? "#2db7f5" : "#87d068",
                  color: "#fff",
                  padding: "4px 12px",
                  borderRadius: "50px",
                  fontSize: "12px",
                  fontWeight: "600",
                  display: "inline-flex",
                  alignItems: "center",
                  height: "28px",
                }}
              >
                {order.type === "elaboracao" ? "Elaboração" : "Renovação"}
              </span>
            )}
          </div>
          <p style={{ fontSize: 12, margin: "5px 0" }}>
            Aberta em {format(new Date(order.create_at), "dd/MM/yyyy HH:mm")}
          </p>
          {order.user && (
            <>
              <h3 style={{ marginTop: 10 }}>Franqueado</h3>
              <Contact>
                <img
                  src={order.user.photo ? order.user.photo_url : photoUser}
                />
                <p>{order.user.name}</p>
              </Contact>
            </>
          )}
          {order.collaborator && (
            <>
              <h3 style={{ marginTop: 10 }}>Técnico</h3>
              <Contact>
                <img
                  src={
                    order.collaborator.photo
                      ? order.collaborator.photo_url
                      : photoUser
                  }
                />
                <p>{order.collaborator.name}</p>
              </Contact>
            </>
          )}
          {order.order_doc_recused && (
            <>
              <h3>Visualizar OS que foi solicitada a revisão</h3>
              <Button
                type="primary"
                onClick={() => {
                  navigate(`/admin/os/${order.order_linked_id}`);
                }}
                style={{
                  marginBottom: 15,
                  height: 40,
                  width: 150,
                  borderRadius: 50,
                  fontWeight: 600,
                }}
              >{`Visualizar OS: ${order.order_linked_id}`}</Button>
            </>
          )}
          <h3>Documentos do Franqueado</h3>
          <Files>
            {!files.find((item) => item.type == "cliente") && (
              <Message style={{ width: "auto", fontSize: 14 }}>
                Nenhum documento enviado até o momento
              </Message>
            )}
            {files.map((item) => {
              if (item.type == "cliente") {
                return (
                  <div key={item.file}>
                    <p>{String(item.file).substr(33)}</p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        minHeight: 20,
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <MdDownload
                        onClick={() => {
                          window.open(
                            "https://guruseg-data.s3.sa-east-1.amazonaws.com/" +
                              item.file,
                          );
                        }}
                        style={{ cursor: "pointer", marginLeft: 10 }}
                        size={22}
                        color="#000"
                      />
                    </div>
                  </div>
                );
              }
            })}
          </Files>
          <h3>Documentos do Técnico</h3>
          <Files>
            {!files.find((item) => item.type == "tecnico") && (
              <Message style={{ width: "auto", fontSize: 14 }}>
                Nenhum documento enviado até o momento
              </Message>
            )}
            {files.map((item) => {
              if (item.type == "tecnico") {
                return (
                  <div key={item.file}>
                    <p>{String(item.file).substr(33)}</p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        minHeight: 20,
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <MdDownload
                        onClick={() => {
                          window.open(
                            "https://guruseg-data.s3.sa-east-1.amazonaws.com/" +
                              item.file,
                          );
                        }}
                        style={{ cursor: "pointer", marginLeft: 10 }}
                        size={22}
                        color="#000"
                      />
                    </div>
                  </div>
                );
              }
            })}
          </Files>
          {!!order.collaborators && (
            <>
              <h3 style={{ marginBottom: 5 }}>Funcionários</h3>
              <p style={{ marginBottom: 15 }}>{order.collaborators}</p>
            </>
          )}
          {order.observation && (
            <>
              <h3 style={{ marginBottom: 5 }}>Observação do Franqueado</h3>
              <p style={{ marginBottom: 15 }}>{order.observation}</p>
            </>
          )}
          {order.observationCollaborator && (
            <>
              <h3 style={{ marginBottom: 5 }}>Observação do Técnico</h3>
              <p style={{ marginBottom: 15 }}>
                {order.observationCollaborator}
              </p>
            </>
          )}
          <h3 style={{ marginBottom: 5 }}>Setor</h3>
          <p style={{ marginBottom: 15 }}>{order.sector}</p>
          <div
            className="service"
            style={{ border: "none", padding: "0 25px" }}
          >
            <p style={{ flex: 1 }}>Serviço</p>
            <p>Quantidade</p>
          </div>
          <Resume>
            <div>
              {order?.items?.map((item) => {
                return (
                  <div className="service">
                    <p style={{ flex: 1 }}>{item.name}</p>
                    <p>{item.amount}x</p>
                  </div>
                );
              })}
            </div>
            <div class="checkout-summary">
              <div class="left-section">
                {order.asaas_integration && (
                  <Status status={order.status_payment} isPayment={true} />
                )}
                {order.redemption && (
                  <p class="discount-info">
                    Cupom aplicado:
                    <span style={{ color: "#FF0000", marginLeft: 10 }}>
                      {order.redemption.name.toUpperCase()}
                    </span>
                  </p>
                )}
              </div>
              <div class="right-section">
                <div class="line">
                  <span>Total</span>
                  <span class="amount">{getValue(order.totalValue || 0)}</span>
                </div>

                {order.redemption && (
                  <div class="line">
                    <span>Desconto</span>
                    <span class="amount">
                      {getValue(order.redemption.value)}
                    </span>
                  </div>
                )}
                <div class="line">
                  <span class="badge">{order.totalServices} itens</span>
                  <span class="final-label">Valor final</span>
                  <span class="amount">
                    {getValue(
                      order.redemption
                        ? order.totalValue - order.redemption.value
                        : order.totalValue || 0,
                    )}
                  </span>
                </div>
              </div>
            </div>
          </Resume>
          <Actions>
            {!!order.messages.length && (
              <Button
                type="primary"
                onClick={async () => {
                  setVisibleModalMessage(true);
                }}
              >
                Ver Mensagens
              </Button>
            )}
            {order.urgent &&
              order.status_payment == "confirmado" &&
              !order.collaborator_id && (
                <Button
                  type="primary"
                  onClick={async () => {
                    setCollaborator_id("");
                    setVisibleModalSend(true);
                  }}
                >
                  Selecionar Técnico
                </Button>
              )}
            {order.collaborator_id && (
              <Button
                type="primary"
                onClick={async () => {
                  setCollaborator_id("");
                  setVisibleModalHandle(true);
                }}
              >
                Alterar Técnico
              </Button>
            )}
          </Actions>
        </>
      )}
      <Modal
        title="Mensagens"
        width={500}
        open={visibleModalMessage}
        okText={"FECHAR"}
        cancelButtonProps={{
          style: {
            display: "none",
          },
        }}
        onCancel={() => {
          setVisibleModalMessage(false);
        }}
        onOk={() => {
          setVisibleModalMessage(false);
        }}
      >
        <div
          className="chat-window-body"
          style={{
            display: "flex",
            padding: 16,
            margin: "15px 0",
            height: "55vh",
            overflowY: "auto",
            flexDirection: "column-reverse",
          }}
        >
          {order?.messages?.map((msg, index) => {
            const messageClasses = [
              "message",
              msg.type === "cliente" ? "sent" : "received",
            ].join(" ");

            return (
              <div key={msg.id || index} className={messageClasses}>
                <strong>
                  {msg.type == "tecnico" ? "Técnico: " : "Franqueado: "}
                </strong>
                <div className={`message-content`}>
                  <p>{msg.message}</p>
                </div>
                <div
                  className="message-header"
                  style={{
                    display: "flex",
                    justifyContent:
                      msg.type === "cliente" ? "flex-end" : "flex-start",
                    gap: "8px",
                  }}
                >
                  <span
                    className="time-label"
                    style={{
                      fontSize: "0.7rem",
                      margin: "5px 0",
                      color: "#888",
                    }}
                  >
                    {format(
                      new Date(msg.create_at),
                      isToday(new Date(msg.create_at))
                        ? "HH:mm"
                        : "dd/MM/yyyy HH:mm",
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </Modal>
      <Modal
        title="Enviar OS para o Técnico"
        width={500}
        open={visibleModalSend}
        confirmLoading={isLoadingModal}
        cancelText={"FECHAR"}
        okText={"CONFIRMAR"}
        onCancel={() => {
          setVisibleModalSend(false);
        }}
        onOk={() => {
          sendOS();
        }}
      >
        <ViewInput style={{ width: "100%" }}>
          <p>Selecionar Técnico</p>
          <Select
            placeholder="selecionar técnico"
            value={collaborator_id || null}
            showSearch
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setCollaborator_id(value);
            }}
          >
            {collaborators.map((item) => {
              return <Select.Option value={item.id}>{item.name}</Select.Option>;
            })}
          </Select>
        </ViewInput>
      </Modal>
      <Modal
        title="Alterar Técnico da OS"
        width={500}
        open={visibleModalHandle}
        confirmLoading={isLoadingModal}
        cancelText={"FECHAR"}
        okText={"CONFIRMAR"}
        onCancel={() => {
          setVisibleModalHandle(false);
        }}
        onOk={() => {
          handleTecnico();
        }}
      >
        <p
          style={{
            margin: "15px 0 10px 0",
            fontSize: 15,
            fontWeight: 500,
          }}
        >
          Técnico atual: {order.collaborator?.name}
        </p>
        <ViewInput style={{ width: "100%" }}>
          <p>Selecionar Novo Técnico</p>
          <Select
            placeholder="selecionar técnico"
            value={collaborator_id || null}
            showSearch
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setCollaborator_id(value);
            }}
          >
            {collaborators.map((item) => {
              if (item.id != order.collaborator?.id) {
                return (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                );
              }
            })}
          </Select>
        </ViewInput>
      </Modal>
    </Container>
  );
}
